/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Ai_Tailored_TitleInputs */

const en_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Tailored for Every Application`)
};

const de_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-massgeschneidert fuer jede Bewerbung`)
};

const fr_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA adaptee a chaque candidature`)
};

const es_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA adaptada a cada solicitud`)
};

const it_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA su misura per ogni candidatura`)
};

const nl_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-afgestemd op elke sollicitatie`)
};

const pl_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI dopasowane do kazdej aplikacji`)
};

const fi_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoalyraataloity jokaiseen hakemukseen`)
};

const da_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-tilpasset til hver ansoegning`)
};

const sv_landing_feature_ai_tailored_title = /** @type {(inputs: Landing_Feature_Ai_Tailored_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-anpassad foer varje ansokan`)
};

/**
* | output |
* | --- |
* | "AI-Tailored for Every Application" |
*
* @param {Landing_Feature_Ai_Tailored_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_ai_tailored_title = /** @type {((inputs?: Landing_Feature_Ai_Tailored_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Ai_Tailored_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_ai_tailored_title(inputs)
	if (locale === "fr") return fr_landing_feature_ai_tailored_title(inputs)
	if (locale === "es") return es_landing_feature_ai_tailored_title(inputs)
	if (locale === "it") return it_landing_feature_ai_tailored_title(inputs)
	if (locale === "nl") return nl_landing_feature_ai_tailored_title(inputs)
	if (locale === "pl") return pl_landing_feature_ai_tailored_title(inputs)
	if (locale === "fi") return fi_landing_feature_ai_tailored_title(inputs)
	if (locale === "da") return da_landing_feature_ai_tailored_title(inputs)
	if (locale === "sv") return sv_landing_feature_ai_tailored_title(inputs)
	return en_landing_feature_ai_tailored_title(inputs)
});